import { Component, Input, OnInit } from '@angular/core';
import { APP_ICONS } from '../../icons/app-icons';

@Component({
  selector: 'app-metro-profile',
  templateUrl: './metro-profile.component.html',
  standalone: false
})
export class MetroProfileComponent {

  @Input() imageUrl: string = '';
  @Input() name: string = '';
  @Input() role: string = '';
  @Input() connectedSince: string = '';
  @Input() title: string = 'Mi Sommelier';
  @Input() description: string = '';
  @Input() primaryButtonLabel: string = '';
  @Input() secondaryButtonLabel: string = '';
  @Input() linkToShare: string = "https://tusitio.com/perfil/sommelier"; // o lo recibís por input
  @Input() waHref: string | null = null;

  @Input() onPrimaryClick: () => void = () => { };
  @Input() onSecondaryClick: () => void = () => { };

  ICON_COPY = APP_ICONS.copy;

  copyLink() {
    navigator.clipboard.writeText(this.linkToShare).then(() => {
    });
  }

  shareLink() {
    if (navigator.share) {
      navigator.share({
        title: 'Mirá este perfil',
        text: 'Te comparto este link:',
        url: this.linkToShare,
      }).catch(err => console.error('Error al compartir:', err));
    } else if (this.waHref) {
      window.open(this.waHref, '_blank');
    } else {
      this.copyLink();
    }
  }

  onImageError(event: Event) {
  const target = event.target as HTMLImageElement;
  target.src = 'assets/images/profile.png'; // ruta a tu imagen por defecto
}
}
